// extracted by mini-css-extract-plugin
export default {"container":"Works_container__BYe5w","wrapper":"Works_wrapper__v4rwU","cardWrapper":"Works_cardWrapper__6kRF3","card":"Works_card__ZyhMb"};